function WidgetPendingActionsSettingsController(Widget, Translation) {
    'ngInject';

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.Widget = Widget;
    vm.Translation = Translation;
}

window.angular
    .module('Controllers')
    .controller('WidgetPendingActionsSettingsController', WidgetPendingActionsSettingsController);
